import React from 'react';
import { useSelector } from 'react-redux';
import { isoCountries } from '@mm/constants/countries';
import { chatWidgetTroubleshootingLastResultSelector } from '@mm/state/selectors/chatWidgetTroubleshootingSelectors';
import {
  ChatWidgetTroubleshootingToolResultTypes,
  Result,
} from '../ChatWidgetTroubleshootingToolResult';

type Props = {
  isXRay?: boolean;
};

export const useFBPageCountryRestrictions = (props: Props): Result => {
  const { isXRay } = props;
  const result = useSelector(chatWidgetTroubleshootingLastResultSelector);
  if (!result || isXRay) {
    return;
  }

  if (
    result.localTests.chatWidgetChannel !== 'facebook' ||
    !result.backendTests.facebookPageSettings
  ) {
    return;
  }

  const countryCodes =
    result.backendTests.facebookPageSettings.countryRestrictions?.countries ??
    [];
  if (countryCodes.length === 0) {
    return;
  }

  const formattedCountryList = countryCodes
    .map(cc => isoCountries[cc])
    .join(', ');
  if (
    result.backendTests.facebookPageSettings.countryRestrictions
      ?.restrictionType === 'whitelist'
  ) {
    return {
      result: 'info',
      type: ChatWidgetTroubleshootingToolResultTypes.FBPageCountryRestrictions,
      description: (
        <>
          Facebook Page has a country restriction. Your chat widget will only be
          visible to users who are signed into Facebook and are in the following
          countries: {formattedCountryList}
          <a
            className="chat-widget-troubleshooting-tool-result__external-link"
            href={`https://www.facebook.com/${result.localTests.fbPageId}/settings/?section=country_restrictions&tab=settings`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Edit Page Settings
          </a>
        </>
      ),
    };
  }
  return {
    result: 'info',
    type: ChatWidgetTroubleshootingToolResultTypes.FBPageCountryRestrictions,
    description: (
      <>
        Facebook Page has a country restriction. Your chat widget will only be
        visible to users who are signed into Facebook and are not in the
        following countries: {formattedCountryList}
        <a
          className="chat-widget-troubleshooting-tool-result__external-link"
          href={`https://www.facebook.com/${result.localTests.fbPageId}/settings/?section=country_restrictions&tab=settings`}
          target="_blank"
          rel="noopener noreferrer"
        >
          Edit Page Settings
        </a>
      </>
    ),
  };
};
